import { convertToMapById } from "helpers/convertToMap";
import { convertToObjById } from "helpers/convertToObject";

export const TABULATOR_SELECTED = 'TABULATOR_SELECTED';
export const GET_TABULATORS = 'GET_TABULATORS';
export const CREATE_TABULATOR = 'CREATE_TABULATOR';
export const MOD_TABULATOR = 'MOD_TABULATOR';
export const DELETE_TABULATOR = 'DELETE_TABULATOR';
export const RESET_TABULATOR_SELECTED = 'RESET_TABULATOR_SELECTED';
export const ADD_TABULATOR_MODE = 'ADD_TABULATOR_MODE';
export const EDIT_TABULATOR_MODE = 'EDIT_TABULATOR_MODE';
export const CHECK_ADD_TABULATOR_MODE_PERMIT = 'CHECK_ADD_TABULATOR_MODE_PERMIT';
export const DELETE_TABULATOR_MODE = 'DELETE_TABULATOR_MODE';
export const CLEAR_TABULATORS = 'CLEAR_TABULATORS';

const INITIAL_STATE = {
  tabulatorSelected: null,
  tabulatorsObj: {},
  tabulatorsArr: [],
  addTabulator: true,
  addMode: false,
  deleteMode: false,
}

export const tabulatorsCatalogReducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {

    case ADD_TABULATOR_MODE:
      return {
        ...state,
        addMode: true,
        deleteMode: false
      }

    case EDIT_TABULATOR_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      }

    case DELETE_TABULATOR_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      }
    
    case CHECK_ADD_TABULATOR_MODE_PERMIT:
      return {
        ...state,
        addTabulator: action.payload,
      }

    case GET_TABULATORS: {
      const filteredTabulators = action.payload.map(tabulator => {
        return {
          ...tabulator,
          rangesNum: tabulator?.ranges?.length
        }
      });
      const listTabulators = convertToObjById(filteredTabulators);
      return {
        ...state,
        tabulatorsObj: listTabulators,
        tabulatorsArr: filteredTabulators,
      }
    }

    case TABULATOR_SELECTED:
      return {
        ...state,
        tabulatorSelected: action.payload
      }

    case RESET_TABULATOR_SELECTED:
      return {
        ...state,
        tabulatorSelected: null
      }

    case CREATE_TABULATOR: {
      const addingTabulator = [action.payload, ...state.tabulatorsArr]
      const newTabulators = convertToObjById(addingTabulator)
      return {
        ...state,
        tabulatorsObj: newTabulators,
        tabulatorsArr: addingTabulator
      }
    }

    case MOD_TABULATOR: {
      const editedTabulators = {
        ...state.tabulatorsObj,
        [action.payload.id]: {
          ...state.tabulatorsObj[action.payload.id],
          ...action.payload
        },
      }
      return {
        ...state,
        tabulatorsObj: editedTabulators,
        tabulatorsArr: convertToMapById(editedTabulators)
      }
    }

    case DELETE_TABULATOR: {
      const dataArray = state.tabulatorsArr.filter(tabulator => tabulator.id !== action.payload)
      return {
        ...state,
        tabulatorsObj: convertToObjById(dataArray),
        tabulatorsArr: dataArray
      }
    }

    case CLEAR_TABULATORS:
      return {
          ...state,
          ...INITIAL_STATE,
      };

    default :
      return state
  }
}